export const giftAddedEvent = 'giftAddedToCart';
export const cartUpdatedEvent = 'cartUpdatedEvent';
